/**
 * Map machine billing error codes to user-facing alert copy.
 *
 * @param {Record<string, string[]>|null|undefined} errors
 * @returns {Record<string, string[]>|null|undefined}
 */
export function mapBillingApiErrors(errors) {
  if (!errors || typeof errors !== 'object') {
    return errors;
  }

  const mapped = {};
  Object.keys(errors).forEach((field) => {
    const messages = errors[field];
    if (!Array.isArray(messages)) {
      mapped[field] = messages;
      return;
    }
    mapped[field] = messages.map((message) => {
      if (message === 'insufficient_credits') {
        return 'Insufficient credit balance for this plan. Top up credits and try again.';
      }
      return message;
    });
  });
  return mapped;
}

export const INSUFFICIENT_CREDITS_MESSAGE =
  'Insufficient credit balance for this plan. Top up credits and try again.';
